/* stylelint-disable declaration-empty-line-before */
import styled, { css } from 'styled-components';

import { SignupVersions } from '@/core/interfaces/common';

import mediaQueries from '@/utils/mediaQueries';
import { colors } from '@/utils/constants';

import {
  HeadlineDescription,
  TextDescription,
  WhyTakeActionWrapper,
} from '@/themes/globalStyles';

const {
  small,
  tablet,
  desktop,
} = mediaQueries;

export const StyledWhyTakeActionWrapper = styled(WhyTakeActionWrapper)<{ version: SignupVersions }>`
  display: flex;
  flex-direction: column;

  ${HeadlineDescription} {
    order: ${({ version }) => (version === SignupVersions.VERSION_3 ? '1' : 'unset')};
  }

  ${TextDescription} {
    order: ${({ version }) => (version === SignupVersions.VERSION_3 ? '2' : 'unset')};
  }
`;

export const Form = styled.div<{ version: SignupVersions }>`
  max-width: 100%;

  ${({ version }) => version !== SignupVersions.VERSION_3 && css`
    position: relative;
    z-index: 1;
    width: 1064px;
    margin: -200px 16px 40px;
    border-radius: 4px;
    padding: 24px;
    background-color: ${colors.white};

    @media ${desktop} {
      padding: 24px 108px;
    }
  `}
`;

export const FormWrapper = styled.div<{ version: SignupVersions }>`
  ${({ version }) => {
    switch (version) {
      case SignupVersions.VERSION_3: {
        return css`
          position: relative;
          z-index: 1;
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 52px;
          margin: -200px 16px 40px;
          border-radius: 4px;
          padding: 24px;
          background-color: ${colors.white};

          @media ${small} {
            display: flex;
            flex-direction: column-reverse;
          }
        `;
      }

      case SignupVersions.VERSION_2:
      default: {
        return css`
          display: flex;
          flex-direction: column-reverse;
          align-items: center;
          margin-right: 16px;
          margin-left: 16px;

          @media ${tablet} {
            margin-right: 54px;
            margin-left: 54px;
          }
        `;
      }
    }
  }}
`;
